import { render, staticRenderFns } from "./PersonalInfoField.vue?vue&type=template&id=dd205e28"
import script from "./PersonalInfoField.vue?vue&type=script&lang=js"
export * from "./PersonalInfoField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports